var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgList(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.99776 0.27345C6.94932 0.2745 6.90101 0.279069 6.85323 0.287122H1.01339C0.748178 0.287149 0.49384 0.392514 0.306309 0.580045C0.118779 0.767575 0.0134133 1.02191 0.0133868 1.28712V9.11915C-0.00446226 9.22714 -0.00446226 9.33733 0.0133868 9.44532V17.2871C0.0134133 17.5523 0.118779 17.8067 0.306309 17.9942C0.49384 18.1817 0.748178 18.2871 1.01339 18.2871H6.84542C6.95341 18.305 7.0636 18.305 7.17159 18.2871H12.8454C12.9534 18.305 13.0636 18.305 13.1716 18.2871H19.0134C19.2786 18.2871 19.5329 18.1817 19.7205 17.9942C19.908 17.8067 20.0134 17.5523 20.0134 17.2871V9.45509C20.0312 9.3471 20.0312 9.23691 20.0134 9.12892V1.28712C20.0134 1.02191 19.908 0.767575 19.7205 0.580045C19.5329 0.392514 19.2786 0.287149 19.0134 0.287122H13.1677C13.1115 0.277737 13.0547 0.273163 12.9978 0.27345C12.9493 0.2745 12.901 0.279069 12.8532 0.287122H7.16768C7.11154 0.277737 7.05469 0.273163 6.99776 0.27345ZM2.01339 2.28712H6.01339V8.28712H2.01339V2.28712ZM8.01339 2.28712H12.0134V8.28712H8.01339V2.28712ZM14.0134 2.28712H18.0134V8.28712H14.0134V2.28712ZM2.01339 10.2871H6.01339V16.2871H2.01339V10.2871ZM8.01339 10.2871H12.0134V16.2871H8.01339V10.2871ZM14.0134 10.2871H18.0134V16.2871H14.0134V10.2871Z",
    fill: "#6F47EB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgList);
export default __webpack_public_path__ + "static/media/list.cd4ead612f505ec8865f6009c57c24f7.svg";
export { ForwardRef as ReactComponent };